var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _g, _rect3, _rect4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H14.5C15.0304 9 15.5391 9.21071 15.9142 9.58579C16.2893 9.96086 16.5 10.4696 16.5 11C16.5 11.5304 16.2893 12.0391 15.9142 12.4142C15.5391 12.7893 15.0304 13 14.5 13H14",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H14V13.5C14 14.0304 13.7893 14.5391 13.4142 14.9142C13.0391 15.2893 12.5304 15.5 12 15.5H8C7.46957 15.5 6.96086 15.2893 6.58579 14.9142C6.21071 14.5391 6 14.0304 6 13.5V9Z",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5V7",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5V7",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5V7",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_8345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9H20.5C21.0304 9 21.5391 9.21071 21.9142 9.58579C22.2893 9.96086 22.5 10.4696 22.5 11C22.5 11.5304 22.2893 12.0391 21.9142 12.4142C21.5391 12.7893 21.0304 13 20.5 13H20",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9H20V13.5C20 14.0304 19.7893 14.5391 19.4142 14.9142C19.0391 15.2893 18.5304 15.5 18 15.5H14C13.4696 15.5 12.9609 15.2893 12.5858 14.9142C12.2107 14.5391 12 14.0304 12 13.5V9Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5.5V7",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5V7",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5V7",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#979797"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 22,
    height: 22,
    rx: 11,
    fill: "black",
    fillOpacity: 0.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1389_8345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 9H26.5C27.0304 9 27.5391 9.21071 27.9142 9.58579C28.2893 9.96086 28.5 10.4696 28.5 11C28.5 11.5304 28.2893 12.0391 27.9142 12.4142C27.5391 12.7893 27.0304 13 26.5 13H26",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9H26V13.5C26 14.0304 25.7893 14.5391 25.4142 14.9142C25.0391 15.2893 24.5304 15.5 24 15.5H20C19.4696 15.5 18.9609 15.2893 18.5858 14.9142C18.2107 14.5391 18 14.0304 18 13.5V9Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 5.5V7",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 5.5V7",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5.5V7",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_8345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(11 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1389_8345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(17 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListings);
export default __webpack_public_path__ + "static/media/listings.4549d53d96ba221cf1920a5a27eac438.svg";
export { ForwardRef as ReactComponent };